/*
<div class="js-product-sizer" data-scope="some-id">

  <!-- Size selector of model 1 -->
  <div class="sizes__wrapper">
    <span class="sizes__button">Select size</span>
    <ul class="sizes__list">
      <li class="sizes__size">
        <span class="sizes__info">Size 1</span>
      </li>
      <li class="sizes__size">[...]</li>
    </ul>
  </div>

  <!-- Size selector of model 2 -->
  <div class="sizes__wrapper">
    [...]
  </div>

  <!-- Size selector of model 3 -->
  [...]
</div>
*/

export function init() {
  const productSizers = cube.$$('.js-product-sizer:not(.built)');

  // Build on document ready
  productSizers.forEach(productSizer => {
    const modelSelectors = productSizer.$$('.sizes__wrapper');
    const scope = cube.$id(`${productSizer.dataset.scope}`);

    if (!productSizer.classList.contains('no-multisku')) {
      // Build each model sizer for the product
      modelSelectors.forEach(selector => {
        buildSizer(selector, scope);
      });

      // Update model sizer display on 'modelChanged' event
      cube.event.on('modelChanged', modelId => {
        updateModelDisplay(modelId, scope);
      });

      // Close on clicking outside
      document.addEventListener('click', e => {
        closeList(e.target, productSizer);
      });
    } else {
      // Update model sizer display on 'modelChanged' event
      cube.event.on('modelChanged', modelId => {
        updateSoloskuModelDisplay(modelId, scope);
      });
    }

    productSizer.classList.add('built');
  });
}

function toggleSelector() {
  if (this.classList.contains('sizes__button--selected'))
    this.classList.remove('sizes__button--selected');
  else this.classList.add('sizes__button--selected');
}

function buildSizer(sizer, scope) {
  if (!sizer.closest('.no-multisku'))
    sizer.$('.sizes__button').addEventListener('click', toggleSelector);

  const sizes = sizer.$$('.sizes__size');
  sizes.forEach(size => {
    size.addEventListener('click', () => {
      updateSkuDisplay(size.dataset.id, scope);
    });
  });
}

function updateSoloskuModelDisplay(modelId, scope) {
  const sizeWrappers = scope.$$('.sizes__wrapper');
  const sizeWrapperTo = scope.$(`.sizes__wrapper[data-id="${modelId}"]`);
  const soloSku = sizeWrapperTo.$('.sizes__size');

  sizeWrappers.forEach(sizeWrapper => {
    sizeWrapper.classList.remove('sizes__wrapper--visible');
  });

  if (!sizeWrapperTo.dataset.usize)
    sizeWrapperTo.classList.add('sizes__wrapper--visible');

  updateSkuDisplay(soloSku.dataset.id, scope);
}

function updateModelDisplay(modelId, scope) {
  const sizeSelectors = scope.$$('.sizes__wrapper');
  const sizeSelectorFrom = scope.$('.sizes__wrapper--visible') || null;
  const sizeSelectorTo =
    scope.$(`.sizes__wrapper[data-id="${modelId}"]`) || null;

  // Display new model size selector
  sizeSelectors
    .filter(size => size.dataset.id === String(modelId))
    .forEach(sizeSelector => {
      // Hide visible selector
      if (sizeSelectorFrom)
        sizeSelectorFrom.classList.remove('sizes__wrapper--visible');

      // Show the new one (if not marked as unique-size)
      if (!sizeSelector.dataset.usize)
        sizeSelector.classList.add('sizes__wrapper--visible');
    });
  // ---

  // Set skuId that will be displayed
  let skuId = null;

  // Default skuId as the first one is selector is marked as unique-size
  if (
    (sizeSelectorTo && sizeSelectorTo.dataset.usize) ||
    sizeSelectorTo.closest('.no-multisku')
  )
    skuId = sizeSelectorTo.$('.sizes__size').dataset.id;

  const sizeSelectorFromText =
    sizeSelectorFrom && sizeSelectorFrom.$('.sizes__button').textContent;

  if (sizeSelectorTo && sizeSelectorFromText) {
    // Check if previously selected size is available in newly selected model
    sizeSelectorTo.$$('.sizes__size').forEach(size => {
      // If so set it as the skuId to display
      if (size.$('.sizes__info').textContent === sizeSelectorFromText)
        skuId = size.dataset.id;
    });
  }
  // ---

  // Update sku display
  updateSkuDisplay(skuId, scope);
}

export function updateSkuDisplay(skuId, scope) {
  const sku = skuId && scope.$(`[data-id="${skuId}"]`);

  const skuSelector = sku && sku.closest('.sizes__wrapper');
  const button = skuSelector && skuSelector.$('.sizes__button');

  if (skuId && cube.$id(`sku-price-${skuId}`)) {
    cube.$id('current-price-container').innerHTML = cube.$id(`sku-price-${skuId}`).innerHTML;
  }


  // Unselect any sku that would be selected
  const selectedSku = scope.$('.sizes__size--selected');
  if (selectedSku) {
    selectedSku.removeAttribute('aria-selected');
    selectedSku.classList.remove('sizes__size--selected');
  }

  // If skuId was explicitly passed in parameters...
  if (sku) {
    // Display right model if it's not already the case
    if (!skuSelector.classList.contains('sizes__wrapper--visible')) {
      scope.$$('.sizes__wrapper--visible').forEach(selector => {
        selector.classList.remove('sizes__wrapper--visible');
      });

      if (!skuSelector.dataset.usize)
        skuSelector.classList.add('sizes__wrapper--visible');
    }

    // Update Button text
    // Set quantity status (Boolean)
    // Remove the class setting the size list as open
    if (button) {
      button.textContent = sku.$('.sizes__info').textContent;
      button.dataset.quantity = sku.dataset.quantity;
      button.classList.remove('sizes__button--selected');
    }

    // Set the new sku as selected
    sku.classList.add('sizes__size--selected');
    sku.setAttribute('aria-selected', true);

    // Set all other selector to the same size if they exist
    const otherSelectors = scope.$$(
      '.sizes__wrapper:not(.sizes__wrapper--visible)'
    );

    otherSelectors.forEach(selector => {
      if (selector.$('.sizes__button')) {
        const sizesInfos = selector.$$('.sizes__info');

        // Reset text to default one...
        selector.$('.sizes__button').textContent = window.Messages('pdm.size');

        sizesInfos.forEach(sizeInfo => {
          if (sizeInfo.textContent === sku.$('.sizes__info').textContent) {
            // ... Assign similar size if found
            selector.$('.sizes__button').textContent = sizeInfo.textContent;
          }
        });
      }
    });

    // If we don't have an explicit skuId, but button states an already existing one
  } else if (
    skuSelector &&
    skuSelector.$('.sizes__button').textContent !== window.Messages('pdm.size')
  ) {
    const sizesInfos = skuSelector.$$('.sizes__info');
    sizesInfos.forEach(sizeInfo => {
      if (sizeInfo.textContent === button.textContent) {
        sizeInfo.closest('.sizes__size').classList.add('sizes__size--selected');
        sizeInfo.closest('.sizes__size').setAttribute('aria-selected', true);
      }
    });
  }

  // Close selector
  if (button) button.classList.remove('sizes__button--selected');

  // build new sku based on selected sie class and send an event
  const newSku =
    cube.$('.sizes__size--selected') &&
    cube.$('.sizes__size--selected').dataset.id;

  const newModel =
    cube.$('.sizes__size--selected') &&
    cube.$('.sizes__size--selected').closest('.sizes__wrapper').dataset.id;

  const eventParams = { skuId: newSku, modelId: newModel, scope };

  cube.event.send('sizeChanged', eventParams);
}

function closeList(target, productSizer) {
  const openedSizers = cube.$$('.sizes__button--selected');

  if (openedSizers.length && !productSizer.contains(target)) {
    openedSizers.forEach(e => e.classList.remove('sizes__button--selected'));
  }
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/size-selector.js